import { useForm } from "react-hook-form";
import Button from "../Reusable/Button";
import APIS from "../../constant/EndPoint";
import usePatchHook from "../../customHooks/usePatchHook";
import TextField from "../Reusable/TextInput";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import PhoneNumberField from "../Reusable/PhoneNumberField";
const MerchantUpdateUserProfile = (props: any) => {
  const { user } = props;
  const {
    register,
    formState: { errors },
    handleSubmit,
    setError,
    control,
  } = useForm<any>({
    defaultValues: async () => {
      // let data: any = await props?.refetch()
      return {
        ...user?.profile,
      };
    },
  });

  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: ["users"],
    navigateURL: "",
  });

  const handleUpdateProfile = async (values: any, setError: any) => {
    const url = `${APIS.PROFILE}${user.profile?.id}/`;
    let formData = {
      ...values,
      email: props?.profile?.user_info?.email ?? props?.email,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <form
        onSubmit={handleSubmit((data: any) =>
          handleUpdateProfile(data, setError)
        )}
        autoComplete="off"
      >
        <div className={tw`grid  md:grid-cols-3 gap-x-4 mx-4`}>
          <TextField
            label={"Full Name"}
            register={register("full_name")}
            errors={errors?.full_name}
          />
          <TextField
            label={"Alt Email"}
            register={register("email")}
            errors={errors?.email}
          />
          <PhoneNumberField
            control={control}
            label={"Alt Mobile NUmber"}
            name={"contact_number"}
            errors={errors?.contact_number}
          />
        </div>
        <div className={tw`flex justify-end w-full`}>
          <div className={tw`w-[100px] mr-4`}>
            <Button label={"Update"} isLoading={false} />
          </div>
        </div>
      </form>
    </>
  );
};

export default MerchantUpdateUserProfile;
